<style scoped>
table {
  width: 100%;
  table-layout: fixed;
}

.dist-panel {
  background: white;
  width: 650px;
  box-shadow: 0 0 2px darkgrey;
  -webkit-box-shadow:0 0 2px darkgrey;
  -moz-box-shadow:0 0 2px darkgrey;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 30px;
}

tr {
  height: 35px;
}

td:nth-child(1) {
  width: 140px;
}

td:nth-child(2) {
  color: black;
}
.centered-modal {
  display: flex;
  justify-content: center;
  align-items: center;
}

.verification-code {
  display: flex;
  justify-content: center;
  align-items: center;
}

.code-input {
  width: 50px;
  height: 50px;
  border: 1px solid #ccc;
  text-align: center;
  font-size: 24px;
  margin: 5px;
}
</style>

<template>
  <div>
    <div class="dist-panel">
      <h2 style="text-align:center;margin:20px;color:black">新点移动研发过程管理应用发布清单</h2>
      <table style="border-collapse:collapse;">
        <tr>
          <td>项目名称</td>
          <td>{{prj.projectname}}</td>
        </tr>
        <tr>
          <td>应用名称</td>
          <td>{{app.appname}}</td>
        </tr>
        <tr>
          <td>平台</td>
          <td>{{app.platform}}</td>
        </tr>
        <tr>
          <td>创建日期</td>
          <td>{{detail.createtime}}</td>
        </tr>
        <tr>
          <td>项目经理</td>
          <td>{{prj.pmname}}</td>
        </tr>

        <tr>
          <td>发布类型</td>
          <td>{{detail.disttype==1?"正式发布":"测试发布"}}</td>
        </tr>
        <tr>
          <td>模块名称</td>
          <td>{{detail.modulename}}</td>
        </tr>
        <tr>
          <td>模块版本号</td>
          <td>{{detail.distversion}}</td>
        </tr>

        <tr>
          <td>zip文件大小</td>
          <td>{{getFileLengthName(file.filelength)}}</td>
        </tr>
        <tr>
          <td>zip下载</td>
          <td>
            <a @click="showVerificationCode">下载</a>
          </td>
        </tr>
        <tr>
          <td>开发者</td>
          <td>{{detail.developername}}</td>
        </tr>
        <tr>
          <td>是否自测</td>
          <td>{{detail.selftest == 1 ? "是":"否"}}</td>
        </tr>
        <tr v-show="detail.selftest == 1">
          <td>自测设备</td>
          <td>{{detail.testdevice}}</td>
        </tr>
        <tr>
          <td>更新说明</td>
          <td style="white-space: pre-wrap">{{detail.updateinfo}}</td>
        </tr>
      </table>
    </div>
    <Modal v-model="showPopup" title="请输入下载码" class="centered-modal">
      <div class="verification-code">
        <input
          v-for="(char, index) in verificationCode"
          :key="index"
          v-model="inputValues[index]"
          :ref="'input_' + index"
          class="code-input"
          maxlength="1"
          @input="handleInput(index)"
          @keydown="handleKeyDown(index)"
          @paste="handlePaste(index)"
        />
      </div>
      <div slot="footer">
        <Button type="text" size="large" @click="closeVerificationCode">取消</Button>
        <Button type="primary" size="large" @click="checkCode">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detail: {},
      app: {},
      prj: {},
      file: {},
      pkg: {},
      showPopup: false,
      verificationCode: ['-', '-', '-', '-', '-', '-'],
      inputValues: ['', '', '', '', '', ''],
      isVerificationCodeValid:false,
      enteredCode: '', // 初始值为空
      inputRefs: [],
    };
  },
  methods: {
    getFileLengthName(filelength) {
      if (filelength / 1024 < 1024) {
        return (filelength / 1024).toFixed(2) + " KB";
      } else if (filelength / 1024 / 1024 < 1024) {
        return (filelength / 1024 / 1024).toFixed(2) + " MB";
      }
      return filelength;
    },
    stringToDate: function(dateStr, separator) {
      if (!separator) {
        separator = "-";
      }
      var dateArr = dateStr.split(separator);
      var year = parseInt(dateArr[0]);
      var month;
      //处理月份为04这样的情况
      if (dateArr[1].indexOf("0") == 0) {
        month = parseInt(dateArr[1].substring(1));
      } else {
        month = parseInt(dateArr[1]);
      }
      var day = parseInt(dateArr[2]);
      var date = new Date(year, month - 1, day);
      return date;
    },
    getDetail() {
      let _this = this;
      this.$http.get({
        method: "/mqms/pkgpub/h5detail",
        params: {
          id: this.$route.params.id
        },
        success: function(data) {
          _this.pkg = data;
          _this.detail = data.dist;
          _this.app = data.app;
          _this.prj = data.project;
          _this.file = data.file;
        },
        failure(code, msg) {}
      });
    },
    showVerificationCode() {
      this.showPopup = true;
      this.inputValues = ['', '', '', '', '', ''];
      this.$nextTick(() => {
        // 在DOM更新后将焦点设置到第一个输入框
        this.$refs['input_0'][0].focus();
      });
    },
    closeVerificationCode() {
      this.showPopup = false;
    },
    checkCode(){
      let _this = this;
      this.enteredCode = this.inputValues.join('');
      if (this.enteredCode.length === 6) {
      this.$http.post({
        method: "mqms/project/checkcode",
        params: {
          filetag: this.detail.filetag,
          downloadcode: this.enteredCode,
        },
        success: function(data) {
           // 验证成功 直接下载
           _this.showPopup = false;
           _this.isVerificationCodeValid = true;
           _this.downloaddist();
        },
        failure(code, msg) {
          _this.$Message.error({
          content:msg
        })
        }
      });        
      } else {
        _this.$Message.error({
          content:"请输入6位验证码"
        })
      }
    },
    downloaddist() {
        const downloadLink = `${this.$axios.defaults.baseURL}/mqms/file/download?id=${this.detail.filetag}&downloadcode=${this.enteredCode}`;
        const link = document.createElement('a');
        link.href = downloadLink;
        link.download = '';
        link.click();
    },
    handleInput(index) {
      if (this.inputValues[index] && index < this.verificationCode.length - 1) {
        this.$refs[this.inputRefs[index + 1]][0].focus();
      }
    },
    handleKeyDown(index) {
      if (index > 0 && event.key === 'Backspace' && !this.inputValues[index]) {
        this.$refs[this.inputRefs[index - 1]][0].focus();
      }
    },
    handlePaste(index) {
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedText = clipboardData.getData('text');
      const characters = pastedText.substring(0, 6).split('');
      for (let i = 0; i < characters.length; i++) {
        if (i < this.inputValues.length) {
          this.inputValues[i] = characters[i];
        }
      }
    }
  },
  mounted() {
    this.getDetail();
    this.inputRefs = this.verificationCode.map((_, index) => `input_${index}`);
  }
};
</script>